import * as React from 'react';
import styled from 'styled-components';
import {
  SectionAuthorBlogListingNotAuthor,
} from './components/SectionAuthorBlogListingNotAuthor';
import { SectionAuthorBlogListingHasAuthor } from './components/SectionAuthorBlogListingHasAuthor';
import { SectionAuthorInfoMobile } from './components/SectionAuthorInfoMobile';
import { s3ToCDN } from '@doltech/utils/lib/url';
import { verticalSpace } from '@doltech/utils/lib/css-style';
import { toScreen } from '@doltech/core/lib/responsive/responsive.util';

const Container = styled.main`
  margin: 0 auto;
  padding: 40px;

  .content {
    ${verticalSpace(40)}
  }

  ${toScreen(768)} {
    margin: 0;
    padding: 0;
    ${verticalSpace(32)}
  }
`;

interface GrammarLandingAuthorPageMobileProps {
  urlInfo?: any;
  data?: any;
  otherUrlInfo?: any;
  isLoggedIn?: any;
}

export const GrammarLandingAuthorPageMobile = (props: GrammarLandingAuthorPageMobileProps) => {
  const { data, isLoggedIn } = props;
  const { authorListData, authorBlogs } = data || {};
  const authorDetailInfo = authorListData?.seoPageAuthor;

  return (
    <Container>
      <div className="content">
        <SectionAuthorInfoMobile
          avatarUrl={s3ToCDN(authorDetailInfo?.avatar?.path)}
          authorName={authorListData?.dol?.title || authorListData?.name}
          positionName={authorDetailInfo?.positionName}
          totalPosts={authorDetailInfo?.totalPost}
          certificates={authorDetailInfo?.certificates}
          otherDocuments={authorDetailInfo?.otherDocuments}
          degrees={authorDetailInfo?.degrees}
          fullDescription={authorDetailInfo?.fullDescription || authorListData?.dol?.description}
        />
        {isLoggedIn ?
          <SectionAuthorBlogListingHasAuthor initData={authorBlogs} authorId={authorListData?.resourceId}/> :
          <SectionAuthorBlogListingNotAuthor initData={authorBlogs} authorId={authorListData?.resourceId}/>
        }
      </div>
    </Container>
  );
};
